import React from 'react';
import Inc from './Include';
import './Talk.scss';

function Talk ({history,newTalk,selected,count,lastCount,hasNext,face}){
	let inner_class = "inner";
	if(newTalk && hasNext){
		if( history.length===1 ){
			inner_class += " skip_single";
		} else {
			inner_class += " skip_double";
		}
	}

	const face_class = "fas fa-" + Inc.FACE_ICON[ face-1 ]+" face";

    let talk2 = null;
	let talk1 = null;
	const last = history.length;
	if( history[last-1] ){
		talk1 = history[last-1];
	}
	if( history[last-2] ){
		talk2 = history[last-2];
	}
	return (
    <div id="talk">
        <div className={inner_class}>
            {talk2 &&
            <div className="reply">
                <i className="fas fa-user-astronaut face"></i>
                {talk2}
            </div>
            }
            {talk1 &&
            <div className="talk">
                <i className={face_class}></i>
                {talk1}
            </div>
            }
            <div className="reply">
                <i className="fas fa-user-astronaut face"></i>
                {selected}
                {count>0 && count<=lastCount &&
                <i className="far fa-comment-dots faa-pulse animated"></i>
                }
            </div>
            {newTalk &&
            <div className="talk">
                <i className={face_class}></i>
                {newTalk}
            </div>
            }
        </div>
    </div>
    );
}

export default Talk;
